<template>
  <footer class="Footer">
    <div class="Footer__content">
      <div class="Footer__block main-info">
        <div class="Footer__block-logo">
          <router-link to="/">
            <img class="Footer__block-logo-image" src="/img/logo.png"/>
          </router-link>
          <div class="Footer__block-socials">
            <a class="Footer__block-socials--link" target="_blank" href="https://www.linkedin.com/company/capsulab-ltd/"> <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'linkedin' }"/></a>
          </div>
        </div>
        <span class="Footer__block-copyright">Copyright 2021</span>
      </div>
      <div class="Footer__block menu">
        <div class="Footer__block-title">
          Menu
        </div>
        <ul class="Footer__block-list">
          <li v-for="(item, index) in routes" :key="index" class="Footer__block-list--item">
            <router-link v-if="!item.hasChild" :to="item.path">
              {{ item.name }}
            </router-link>
            <router-link v-else :to="item.items[0].path">
              {{ item.name }}
            </router-link>
          </li>
          <li class="Footer__block-list--item">
            <router-link to="/contact-us">
              <span>Contact us</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="Footer__block other">
        <div class="Footer__block-title">
          Other
        </div>
        <ul class="Footer__block-list">
          <li class="Footer__block-list--item">
            <router-link to="/privacy-policy">
              Privacy Policy
            </router-link>
          </li>
<!--          <li class="Footer__block-list&#45;&#45;item">-->
<!--            <router-link to="/terms-and-conditions">-->
<!--              Terms and Conditions-->
<!--            </router-link>-->
<!--          </li>-->
        </ul>
      </div>
      <span class="Footer__block-copyright bottom">Copyright 2021</span>
    </div>
  </footer>
</template>

<script>
import { ROUTES } from '@/assets/routes'

export default {
  name: 'Footer',
  data: () => ({
    routes: ROUTES,
    email: '',
    isSendButtonClicked: false,
  })
}
</script>

<style lang="scss">
.Footer {
  background: $color;
  color: #ffffff;
  width: 100%;
  overflow: hidden;
  &__content {
    @include content;
    min-height: $min-footer-width;
    display: grid;
    grid-template-columns: 3fr 1fr 1fr;
    grid-column-gap: 20px;
    font-size: 14px;
    padding: 40px 10px 30px;
    margin-left: auto;
    margin-right: auto;
    @media screen and (max-width: 810px) {
      padding: 15px 3% 0;
      grid-template-areas:
      "mainInfo mainInfo"
      "menu other";
      grid-template-rows: auto auto;
      grid-template-columns: 1fr 2fr;
      grid-gap: 10px;
    }
  }
  &__block {
    padding: 0 15px;
    &-logo {
      width: 200px;
      &-image {
        width: 96%;
      }
    }
    &-title {
      font-size: 18px;
      line-height: 21px;
      text-transform: uppercase;
      color: #8E8BAD;
    }
    &.main-info {
      min-width: 200px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      @media screen and (max-width: 810px) {
        padding-top: 20px;
        justify-content: center;
      }
    }
    &-copyright {
      color: #9A9A9A;
      font-size: 16px;
      &.bottom {
        display: none;
        padding: 30px 0 30px 15px;
      }
      @media screen and (max-width: 810px) {
       display: none;
        &.bottom {
          display: block;
        }
      }
    }
    &-list {
      margin-top: 5px;
      &--item {
        margin: 15px 0;
        line-height: 21px;
        a{
          color: #ffffff;
          font-size: 18px;
        }
      }
    }
    &-text {
      margin-top: 25px;
      color: #ffffff;
      font-size: 18px;
      a, a:visited {
        color: inherit;
      }
    }
    &-socials {
      margin: 30px 0;
      &--link {
        color: #FFFFFF;
        margin-right: 15px;
        svg {
          width: 35px !important;
          height: 35px;
        }
      }
      &:first-child {
        border-radius: 20px;
      }
    }
  }
}
@media screen and (max-width: 810px) {
  .main-info {
    grid-area: mainInfo;
  }
  .menu {
    grid-area: menu;
  }
  .other {
    grid-area: other;
  }
}
</style>
